import { Component, Input } from "@angular/core";
import { DForm1 } from "../formulario/form1";
import { DOperacionesMatematicasServicio } from "@dian-cmp/formulario/src/servicios/doperaciones-matematicas.servicio";
import { DTipoOperacionAritmetica } from "@dian-cmp/formulario";

@Component({
    selector: "dialogo-impuesto-simple",
    templateUrl: "./dialogoimpsimp.component.html",
    styleUrls: ['./dialogoimpsimp.component.css'],
})
export class DialogoImpuestoSimpleComponent {
    total: string = "0";
    // dutilidades: DOperacionesMatematicasServicio;
    @Input() impuestoSimpleTemp: DForm1 = {

        id: 0,
        conceptoPago: 0,
        numeroDeclaracion: 0,
        numeroDocumentoOrigen: 0,
        valorImpuesto: 0,
        valorInteresMora: 0,
        valorSancion: 0,
        total: 0
    };

    constructor(
        public dutilidades: DOperacionesMatematicasServicio
        ) { 
            this.impuestoSimpleTemp.id= 0,
            this.impuestoSimpleTemp.conceptoPago= 0,
            this.impuestoSimpleTemp.numeroDeclaracion= 0,
            this.impuestoSimpleTemp.numeroDocumentoOrigen= 0,
            this.impuestoSimpleTemp.valorImpuesto= 0,
            this.impuestoSimpleTemp.valorInteresMora= 0,
            this.impuestoSimpleTemp.valorSancion= 0,
            this.impuestoSimpleTemp.total= 0
        }




    calcularTotal() {
        this.total = "0";
        this.total = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, "" + this.total, this.impuestoSimpleTemp.valorImpuesto.toString());
        this.total = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, "" + this.total, this.impuestoSimpleTemp.valorInteresMora.toString());
        this.total = this.dutilidades.ejecutarOperacion(DTipoOperacionAritmetica.SUMA, "" + this.total, this.impuestoSimpleTemp.valorSancion.toString());
        this.impuestoSimpleTemp.total = parseInt(this.total);
    }
}


// WEBPACK FOOTER //
// D:/github/490/rec_ng_recibopago490v7/src/app/components/formulario/dialogo-impuesto-simple/dialogoimpsimp.component.ts